import { DrillDownMenuItem } from "@/components/root/drilldown-menu/drilldown-menu.state";
import { CsvReportStatus } from "../data/csv/model";

const delete_report: DrillDownMenuItem = {
  name: "Delete report",
  icon: "Trash",
  disable: false,
  subItems: [],
  isCategory: false,
  isPremium: false,
  action: "delete",
};

const download_report: DrillDownMenuItem = {
  isCategory: false,
  name: "Download report",
  disable: false,
  isPremium: false,
  subItems: [],
  icon: "Download",
  action: "download",
};

const inspect_report: DrillDownMenuItem = {
  isCategory: false,
  name: "View report details",
  disable: false,
  isPremium: false,
  subItems: [],
  icon: "Detection",
  action: "inspect_details",
};

export const get_menu = (
  report_status: CsvReportStatus
): DrillDownMenuItem[] => {
  switch (report_status) {
    case "New":
    case "InProgress":
      return [];
    case "Failed":
      return [inspect_report, delete_report];
    case "Ready":
      return [download_report, inspect_report, delete_report];
  }
};
